// Map from cart contents to the richer model used for editing
// We may be restoring from an old kit that is no longer valid in the current catalog (for reordering old
// kits), so we only overwrite the default state with data we've validated against the catalog.
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { findOrganismByName } from "../KitToFormStateUtilityFunctions";
import { BundleOfKitsPrice, RnaCishCatalogVariantRefProbeSet, RnaCishKitPrice, RnaCishLeicaBuffersComponent, RnaCishLibraryOrganismCustomTargetProbeSet, RnaCishManualBuffersComponent, RnaCishOncoreProXBuffersComponent } from "../rna-fish/KitModel";
import { extractNameBeforeParenthesis } from "../rna-fish/RnaFishKitToFormState";
import { defaultMiscComponentFormState, defaultRnaCishAmpState, defaultRnaCishBufferState, defaultRnaCishCatalogProbeSetState, defaultRnaCishChromogenState } from "./AdminEditKitForm";
import { RnaCishEditableOrganism, RnaCishEditableTarget, } from "./ProbeSetForm";
import { Hapten, HcrAmplifier } from "./RnaCatalog";
export var rnaCishKitToAdminFormState = function (catalog, kit, kitPrice) {
    var probeSetEnabled = false;
    var probeSetState = defaultRnaCishCatalogProbeSetState(catalog);
    var probeSetAmplifier;
    if (kit.probeSetComponent !== undefined) {
        probeSetEnabled = true;
        var findOrganism = function (slo) {
            var orgById = catalog.probeSet.catalog.organisms.find(function (o) { return o.id === slo.id; });
            var orgByName = catalog.probeSet.catalog.organisms.find(function (o) { return o.name === slo.name; });
            return orgById ? orgById : orgByName;
        };
        var findPsf = function (org, family) {
            var psfById = org.probeSetFamilies.find(function (psf) { return psf.id === family.id; });
            var psfByName = org.probeSetFamilies.find(function (psf) { return psf.geneSymbol === family.geneSymbol; });
            return psfById ? psfById : psfByName;
        };
        var findVariant = function (psf, variant) {
            var variantById = psf.variants.find(function (v) { return v.id === variant.id; });
            var variantByName = psf.variants.find(function (v) { return v.name === variant.name; });
            return variantById ? variantById : variantByName;
        };
        var findRnaCishMatchingCatalogScaleOrDefault = function (scaleSlides) {
            var found = catalog.probeSet.catalog.cishScale.find(function (s) { return s === scaleSlides; });
            if (found !== undefined) {
                return found;
            }
            return catalog.probeSet.catalog.cishDefaultScale;
        };
        var findRnaCishMatchingCustomScaleOrDefault = function (scaleSlides) {
            var found = catalog.probeSet.custom.cishScale.find(function (s) { return s === scaleSlides; });
            if (found !== undefined) {
                return found;
            }
            return catalog.probeSet.custom.cishDefaultScale;
        };
        var probeSet_1 = kit.probeSetComponent.probeSet;
        if (probeSet_1 instanceof RnaCishCatalogVariantRefProbeSet) {
            var probeSetComponent = kit.probeSetComponent;
            probeSetState = __assign(__assign({}, probeSetState), { scale: findRnaCishMatchingCatalogScaleOrDefault(probeSetComponent.scale.slides), probeHybridizationAScale: findRnaCishMatchingCatalogScaleOrDefault(probeSetComponent.probeHybridizationAScale.slides), probeHybridizationBScale: findRnaCishMatchingCatalogScaleOrDefault(probeSetComponent.probeHybridizationBScale.slides), probeLotNumber: kitPrice ? probeSet_1.probeLotNumber : undefined });
            var customerProvidedAmplifier = findRnaCishMatchingAmplifierOrDefault(probeSet_1.hcrAmplifier, catalog.cishAmplifier);
            var customerProvidedOrganism = findOrganismByName(extractNameBeforeParenthesis(probeSet_1.customerOrganismName), catalog);
            if (customerProvidedOrganism != null) {
                var customerProvidedTarget = customerProvidedOrganism.probeSetFamilies.find(function (psf) {
                    return psf.geneSymbol.trim().toLowerCase()
                        === extractNameBeforeParenthesis(probeSet_1.customerTargetName).trim().toLowerCase();
                });
                if (customerProvidedTarget != null) {
                    var customerProvidedVariant = customerProvidedTarget.variants.find(function (v) {
                        var accession = v.accession ? v.accession.transcriptAccession : "";
                        return v.targetMrnaSeq === probeSet_1.customerSequence
                            && v.probeSetSize === probeSet_1.customerProbeSetSize
                            && accession.trim().toLowerCase()
                                === probeSet_1.customerAccessionNum.trim().toLowerCase();
                    });
                    if (customerProvidedVariant != null) {
                        probeSetState = __assign(__assign({}, probeSetState), { organism: RnaCishEditableOrganism.fromLibOrg(customerProvidedOrganism), target: RnaCishEditableTarget.fromLibTarget(customerProvidedVariant), targets: [
                                {
                                    id: customerProvidedTarget.id,
                                    geneSymbol: customerProvidedTarget.geneSymbol,
                                    description: customerProvidedTarget.description,
                                    synonyms: customerProvidedTarget.synonyms
                                }
                            ], hcrAmplifier: customerProvidedAmplifier });
                    }
                    else {
                        probeSetState = __assign(__assign({}, probeSetState), { organism: RnaCishEditableOrganism.fromLibOrg(customerProvidedOrganism), target: new RnaCishEditableTarget(customerProvidedTarget.geneSymbol, customerProvidedTarget.description, probeSet_1.customerAccessionNum, probeSet_1.customerSequence, probeSet_1.customerProbeSetSize, customerProvidedTarget.id, false, false, undefined), targets: [
                                {
                                    id: customerProvidedTarget.id,
                                    geneSymbol: customerProvidedTarget.geneSymbol,
                                    description: customerProvidedTarget.description,
                                    synonyms: customerProvidedTarget.synonyms
                                }
                            ], hcrAmplifier: customerProvidedAmplifier });
                    }
                }
                else {
                    probeSetState = __assign(__assign({}, probeSetState), { organism: RnaCishEditableOrganism.fromLibOrg(customerProvidedOrganism), target: new RnaCishEditableTarget(probeSet_1.customerTargetName, "", probeSet_1.customerAccessionNum, probeSet_1.customerSequence, probeSet_1.customerProbeSetSize, -1, false, false, undefined), hcrAmplifier: customerProvidedAmplifier });
                }
            }
            else {
                probeSetState = __assign(__assign({}, probeSetState), { organism: new RnaCishEditableOrganism(probeSet_1.customerOrganismName, "", -1), target: new RnaCishEditableTarget(probeSet_1.customerTargetName, "", probeSet_1.customerAccessionNum, probeSet_1.customerSequence, probeSet_1.customerProbeSetSize, -1, false, false, undefined), hcrAmplifier: customerProvidedAmplifier });
            }
            probeSetState = __assign({}, probeSetState);
            // If we cannot find the probeDesignOrganism by its id, i.e. a new batch was uploaded then we search by name, which
            // is unique for probeDesignOrganism per batch.
            var probeDesignOrganism = findOrganism(probeSet_1.organism);
            if (probeDesignOrganism !== undefined) {
                // same for probe set family
                var probeDesignTarget = findPsf(probeDesignOrganism, probeSet_1.probeSetFamily);
                if (probeDesignTarget !== undefined) {
                    var probeDesignVariant = findVariant(probeDesignTarget, probeSet_1.variant);
                    if (probeDesignVariant !== undefined) {
                        var hcrAmplifier = findRnaCishMatchingAmplifierOrDefault(probeSet_1.hcrAmplifier, catalog.cishAmplifier);
                        probeSetState = __assign(__assign({}, probeSetState), { target: probeSetState.target.withProbeDesign(probeDesignVariant.id) });
                        probeSetAmplifier = hcrAmplifier;
                    }
                }
            }
        }
        else if (probeSet_1 instanceof RnaCishLibraryOrganismCustomTargetProbeSet) {
            var hcrAmplifier = findRnaCishMatchingAmplifierOrDefault(probeSet_1.hcrAmplifier, catalog.cishAmplifier);
            probeSetState = __assign(__assign({}, probeSetState), { organism: RnaCishEditableOrganism.fromLibOrg(findOrganism(probeSet_1.organism)), target: new RnaCishEditableTarget(probeSet_1.target.name, "", probeSet_1.target.accession, probeSet_1.target.targetMrnaSeq, probeSet_1.probeSetSize, -1, false, false, undefined), hcrAmplifier: hcrAmplifier, scale: findRnaCishMatchingCustomScaleOrDefault(kit.probeSetComponent.scale.slides), probeHybridizationAScale: findRnaCishMatchingCustomScaleOrDefault(kit.probeSetComponent.probeHybridizationAScale.slides), probeHybridizationBScale: findRnaCishMatchingCustomScaleOrDefault(kit.probeSetComponent.probeHybridizationBScale.slides), probeLotNumber: kitPrice ? probeSet_1.probeLotNumber : undefined });
            probeSetAmplifier = hcrAmplifier;
        }
        else {
            var hcrAmplifier = findRnaCishMatchingAmplifierOrDefault(probeSet_1.hcrAmplifier, catalog.cishAmplifier);
            probeSetState = __assign(__assign({}, probeSetState), { organism: new RnaCishEditableOrganism(probeSet_1.organism.name, "", -1), target: new RnaCishEditableTarget(probeSet_1.target.name, "", probeSet_1.target.accession, probeSet_1.target.targetMrnaSeq, probeSet_1.probeSetSize, -1, false, false, undefined), hcrAmplifier: hcrAmplifier, scale: findRnaCishMatchingCustomScaleOrDefault(kit.probeSetComponent.scale.slides), probeHybridizationAScale: findRnaCishMatchingCustomScaleOrDefault(kit.probeSetComponent.probeHybridizationAScale.slides), probeHybridizationBScale: findRnaCishMatchingCustomScaleOrDefault(kit.probeSetComponent.probeHybridizationBScale.slides), probeLotNumber: kitPrice ? probeSet_1.probeLotNumber : undefined });
            probeSetAmplifier = hcrAmplifier;
        }
        if ((kitPrice === null || kitPrice === void 0 ? void 0 : kitPrice.probeSetPriceCustom) === true) {
            probeSetState = __assign(__assign({}, probeSetState), { customPrice: {
                    listPriceCents: 0,
                    effectivePriceCents: kitPrice.probeSetPriceCents,
                } });
        }
    }
    var ampEnabled = false;
    var ampState = defaultRnaCishAmpState(catalog.cishAmplifier);
    if (probeSetAmplifier) {
        ampState = __assign(__assign({}, ampState), { hcrAmplifier: probeSetAmplifier });
    }
    if (kit.amplifierComponent !== undefined) {
        ampEnabled = true;
        ampState = ampKitToAmpFormState(ampState, kit.amplifierComponent, kit.protocolType, catalog, false, kitPrice);
    }
    var chromogenEnabled = false;
    var chromogenState = defaultRnaCishChromogenState();
    if (kit.chromogenComponent != undefined) {
        chromogenEnabled = true;
        chromogenState = chromogenKitToChromogenFormState(chromogenState, kit.chromogenComponent, catalog, false, kitPrice);
    }
    var buffersEnabled = false;
    var bufferState = defaultRnaCishBufferState(catalog);
    if (kit.bufferComponent !== undefined) {
        buffersEnabled = true;
        bufferState = buffersKitToBuffersFormState(bufferState, kit.bufferComponent, catalog, false, kitPrice);
    }
    var allScale;
    if (ampEnabled) {
        allScale = ampState.amplifierScale;
    }
    else if (probeSetEnabled) {
        allScale = probeSetState.scale;
    }
    else if (buffersEnabled) {
        allScale = bufferState.amplificationBufferScale;
    }
    else if (chromogenEnabled) {
        allScale = chromogenState.chromogenScaleSlides;
    }
    else {
        allScale = catalog.cishAmplifier.proDefaultAmplifierScale;
    }
    var reasonForOther = kit.reasonForOther.split("(")[0].trim();
    var reasonForOtherExplanation = extractStringFromParentheses(kit.reasonForOther);
    var miscComponentState = defaultMiscComponentFormState();
    var miscComponentEnabled = false;
    if (kit.miscComponent != null) {
        miscComponentEnabled = true;
        miscComponentState = __assign(__assign({}, miscComponentState), { description: kit.miscComponent.description, scaleInMl: kit.miscComponent.scaleInMl.valueMl, scaleInMlText: String(kit.miscComponent.scaleInMl.valueMl), scaleInSlides: kit.miscComponent.scaleInSlides });
    }
    if ((kitPrice === null || kitPrice === void 0 ? void 0 : kitPrice.miscComponentPriceCustom) === true) {
        miscComponentState = __assign(__assign({}, miscComponentState), { customPrice: {
                listPriceCents: 0,
                effectivePriceCents: kitPrice.miscComponentPriceCents,
            } });
    }
    return {
        scale: allScale,
        protocolType: kit.protocolType,
        config: kit.config,
        ampState: ampState,
        ampEnabled: ampEnabled,
        probeSetEnabled: probeSetEnabled,
        probeSetState: probeSetState,
        comment: kit.comment,
        reasonForOther: reasonForOther,
        reasonForOtherExplanation: reasonForOtherExplanation ? reasonForOtherExplanation.trim() : "",
        errors: [],
        price: undefined,
        priceLoading: false,
        bufferState: bufferState,
        buffersEnabled: buffersEnabled,
        chromogenState: chromogenState,
        chromogenEnabled: chromogenEnabled,
        miscComponentState: miscComponentState,
        miscComponentEnabled: miscComponentEnabled
    };
};
export var ampKitToAmpFormState = function (ampState, ampComponent, protocolType, catalog, manualPro, kitPrice) {
    var ampCatalog = catalog.cishAmplifier;
    var catalogScales = manualPro ? ampCatalog.manualProAmplifierScales : ampCatalog.proAmplifierScales;
    var defaultScale = manualPro ? ampCatalog.manualProDefaultAmplifierScale : ampCatalog.proDefaultAmplifierScale;
    // lookup hcrAmplifier
    var hcrAmplifier = ampCatalog.hcrAmplifiers.find(function (a) { return a.id === ampComponent.hcrAmplifier.id; });
    if (hcrAmplifier !== undefined) {
        ampState = __assign(__assign({}, ampState), { hcrAmplifier: hcrAmplifier });
    }
    else {
        ampState = __assign(__assign({}, ampState), { hcrAmplifier: new HcrAmplifier("NONE") });
    }
    // lookup hapten
    var hapten = ampCatalog.hapten.find(function (h) { return h.id === ampComponent.hapten.id; });
    if (hapten !== undefined) {
        ampState = __assign(__assign({}, ampState), { hapten: hapten });
    }
    else {
        ampState = __assign(__assign({}, ampState), { hapten: new Hapten("NONE") });
    }
    // lookup antiHapten1
    var antiHapten1 = ampCatalog.antiHapten1.find(function (a) { return a.id === ampComponent.antiHapten1.id; });
    if (antiHapten1 !== undefined) {
        ampState = __assign(__assign({}, ampState), { antiHapten1: antiHapten1 });
    }
    else {
        ampState = __assign(__assign({}, ampState), { antiHapten1: { id: "NONE", label: "NONE" } });
    }
    // lookup tyramide hapten
    var tyramideHapten = ampCatalog.tyramideHapten
        .find(function (h) { return h.id === ampComponent.tyramideHapten.id; });
    if (tyramideHapten !== undefined) {
        ampState = __assign(__assign({}, ampState), { tyramideHapten: tyramideHapten });
    }
    else {
        ampState = __assign(__assign({}, ampState), { tyramideHapten: { id: "NONE", label: "NONE" } });
    }
    var amplifierScale = catalogScales.find(function (s) { return s === ampComponent.amplifierScale.slides; });
    if (amplifierScale !== undefined) {
        ampState = __assign(__assign({}, ampState), { amplifierScale: amplifierScale });
    }
    else {
        ampState = __assign(__assign({}, ampState), { amplifierScale: defaultScale });
    }
    var antiHapten1Scale = catalogScales.find(function (s) { return s === ampComponent.antiHapten1Scale.slides; });
    if (antiHapten1Scale !== undefined) {
        ampState = __assign(__assign({}, ampState), { antiHapten1Scale: antiHapten1Scale });
    }
    else {
        ampState = __assign(__assign({}, ampState), { antiHapten1Scale: defaultScale });
    }
    var tyramideHaptenScale = catalogScales.find(function (s) { return s === ampComponent.tyramideHaptenScale.slides; });
    if (tyramideHaptenScale !== undefined) {
        ampState = __assign(__assign({}, ampState), { tyramideHaptenScale: tyramideHaptenScale });
    }
    else {
        ampState = __assign(__assign({}, ampState), { tyramideHaptenScale: defaultScale });
    }
    var antiHapten2ApScale = catalogScales.find(function (s) { return s === ampComponent.antiHapten2ApScale.slides; });
    if (antiHapten2ApScale !== undefined) {
        ampState = __assign(__assign({}, ampState), { antiHapten2ApScale: antiHapten2ApScale });
    }
    else {
        ampState = __assign(__assign({}, ampState), { antiHapten2ApScale: defaultScale });
    }
    var antiHapten2HrpScale = catalogScales.find(function (s) { return s === ampComponent.antiHapten2HrpScale.slides; });
    if (antiHapten2HrpScale !== undefined) {
        ampState = __assign(__assign({}, ampState), { antiHapten2HrpScale: antiHapten2HrpScale });
    }
    else {
        ampState = __assign(__assign({}, ampState), { antiHapten2HrpScale: defaultScale });
    }
    // lookup antiHapten2
    var antiHapten2Ap = ampCatalog.antiHapten2Ap.find(function (a) { var _a; return a.id === ((_a = ampComponent.antiHapten2Ap) === null || _a === void 0 ? void 0 : _a.id); });
    if (antiHapten2Ap !== undefined) {
        ampState = __assign(__assign({}, ampState), { antiHapten2Ap: antiHapten2Ap });
    }
    else {
        ampState = __assign(__assign({}, ampState), { antiHapten2Ap: { id: "NONE", label: "NONE", chromogenCompatibility: "NONE" } });
    }
    // lookup antiHapten2
    var antiHapten2Hrp = ampCatalog.antiHapten2Hrp.find(function (a) { var _a; return a.id === ((_a = ampComponent.antiHapten2Hrp) === null || _a === void 0 ? void 0 : _a.id); });
    if (antiHapten2Hrp !== undefined) {
        ampState = __assign(__assign({}, ampState), { antiHapten2Hrp: antiHapten2Hrp });
    }
    else {
        ampState = __assign(__assign({}, ampState), { antiHapten2Hrp: { id: "NONE", label: "NONE", chromogenCompatibility: "NONE" } });
    }
    ampState = __assign({}, ampState);
    var adminAmpCatalog = catalog.cishAmplifier;
    var enzymeConfig = adminAmpCatalog.enzymes.find(function (e) {
        return e.protocolType.id === protocolType.id
            && e.amplifier.id === (hcrAmplifier === null || hcrAmplifier === void 0 ? void 0 : hcrAmplifier.id)
            && e.hapten.id === (hapten === null || hapten === void 0 ? void 0 : hapten.id)
            && e.antiHapten1.id === (antiHapten1 === null || antiHapten1 === void 0 ? void 0 : antiHapten1.id)
            && e.tyramideHapten.id === (tyramideHapten === null || tyramideHapten === void 0 ? void 0 : tyramideHapten.id)
            && e.antiHapten2Ap.id === (antiHapten2Ap === null || antiHapten2Ap === void 0 ? void 0 : antiHapten2Ap.id)
            && e.antiHapten2Hrp.id === (antiHapten2Hrp === null || antiHapten2Hrp === void 0 ? void 0 : antiHapten2Hrp.id);
    });
    ampState = __assign(__assign({}, ampState), { enzyme: enzymeConfig });
    if (kitPrice instanceof RnaCishKitPrice) {
        if (kitPrice.amplifierPriceCustom) {
            ampState = __assign(__assign({}, ampState), { customPrice: {
                    listPriceCents: 0,
                    effectivePriceCents: kitPrice.amplifierPriceCents,
                } });
        }
    }
    else if (kitPrice instanceof BundleOfKitsPrice) {
        var individualKitPrice = kitPrice.individualKitPrices.find(function (k) { return k.channel === 1; });
        if (individualKitPrice) {
            var ampPrice = individualKitPrice.amplifierPrices.find(function (a) { return a.index === 1; });
            if (ampPrice === null || ampPrice === void 0 ? void 0 : ampPrice.priceCustom) {
                ampState = __assign(__assign({}, ampState), { customPrice: {
                        listPriceCents: 0,
                        effectivePriceCents: ampPrice.priceCents,
                    } });
            }
        }
    }
    return ampState;
};
export var chromogenKitToChromogenFormState = function (chromogenState, chromogenComponent, catalog, manualPro, kitPrice) {
    var chromogenCatalog = catalog.cishChromogens;
    var catalogScales = manualPro ? chromogenCatalog.manualProChromogenScales : chromogenCatalog.proChromogenScales;
    var foundChromogen = chromogenCatalog.chromogens.find(function (c) { var _a; return c.id === ((_a = chromogenComponent.chromogen) === null || _a === void 0 ? void 0 : _a.id); });
    if (foundChromogen !== undefined) {
        chromogenState = __assign(__assign({}, chromogenState), { chromogen: foundChromogen });
    }
    var foundChromogenBuffer = chromogenCatalog.chromogenBuffers.find(function (c) { var _a; return c.id === ((_a = chromogenComponent.chromogenBuffer) === null || _a === void 0 ? void 0 : _a.id); });
    if (foundChromogenBuffer !== undefined) {
        chromogenState = __assign(__assign({}, chromogenState), { chromogenBuffer: foundChromogenBuffer });
    }
    var chromogenScale = catalogScales.find(function (s) { return s === chromogenComponent.chromogenScale.slides; });
    if (chromogenScale !== undefined) {
        chromogenState = __assign(__assign({}, chromogenState), { chromogenScaleSlides: chromogenScale });
    }
    var chromogenBufferScale = catalogScales.find(function (s) { return s === chromogenComponent.chromogenBufferScale.slides; });
    if (chromogenBufferScale !== undefined) {
        chromogenState = __assign(__assign({}, chromogenState), { chromogenBufferScaleSlides: chromogenBufferScale });
    }
    var hematoxylinScale = catalogScales.find(function (s) { return s === chromogenComponent.hematoxylinScale.slides; });
    if (hematoxylinScale !== undefined) {
        chromogenState = __assign(__assign({}, chromogenState), { hematoxylinScaleSlides: hematoxylinScale });
    }
    if (kitPrice instanceof RnaCishKitPrice) {
        if (kitPrice.chromogenPriceCustom) {
            chromogenState = __assign(__assign({}, chromogenState), { customPrice: {
                    listPriceCents: 0,
                    effectivePriceCents: kitPrice.chromogenPriceCents,
                } });
        }
    }
    else if (kitPrice instanceof BundleOfKitsPrice) {
        var individualKitPrice = kitPrice.individualKitPrices.find(function (k) { return k.channel === 1; });
        if (individualKitPrice) {
            var chromogenPrice = individualKitPrice.chromogenPrices.find(function (a) { return a.index === 1; });
            if (chromogenPrice === null || chromogenPrice === void 0 ? void 0 : chromogenPrice.priceCustom) {
                chromogenState = __assign(__assign({}, chromogenState), { customPrice: {
                        listPriceCents: 0,
                        effectivePriceCents: chromogenPrice.priceCents,
                    } });
            }
        }
    }
    return chromogenState;
};
export var buffersKitToBuffersFormState = function (bufferState, buffersComponent, catalog, manualPro, kitPrice) {
    var catalogScales = manualPro ? catalog.cishBuffer.manualProBufferScales : catalog.cishBuffer.proBufferScales;
    var defaultScale = manualPro ? catalog.cishBuffer.manualProDefaultBufferScale : catalog.cishBuffer.proDefaultBufferScale;
    var foundType = catalog.cishBuffer.sampleTypes
        .find(function (t) { return t.id === buffersComponent.sampleType.id; });
    if (foundType !== undefined) {
        bufferState = __assign(__assign({}, bufferState), { sampleType: foundType });
    }
    else {
        bufferState = __assign(__assign({}, bufferState), { sampleType: catalog.cishBuffer.defaultSampleType });
    }
    var amplificationBufferScale = catalogScales
        .find(function (s) { return s === buffersComponent.amplificationBufferScale.slides; });
    if (amplificationBufferScale !== undefined) {
        bufferState = __assign(__assign({}, bufferState), { amplificationBufferScale: amplificationBufferScale });
    }
    else {
        bufferState = __assign(__assign({}, bufferState), { amplificationBufferScale: defaultScale });
    }
    var blockingSolutionScale = catalogScales
        .find(function (s) { return s === buffersComponent.blockingSolutionScale.slides; });
    if (blockingSolutionScale !== undefined) {
        bufferState = __assign(__assign({}, bufferState), { blockingSolutionScale: blockingSolutionScale });
    }
    else {
        bufferState = __assign(__assign({}, bufferState), { blockingSolutionScale: defaultScale });
    }
    var endogenousEnzymeScale = catalogScales
        .find(function (s) { return s === buffersComponent.endogenousEnzymeScale.slides; });
    if (endogenousEnzymeScale !== undefined) {
        bufferState = __assign(__assign({}, bufferState), { endogenousEnzymeScale: endogenousEnzymeScale });
    }
    else {
        bufferState = __assign(__assign({}, bufferState), { endogenousEnzymeScale: defaultScale });
    }
    var preHybridizationScale = catalogScales
        .find(function (s) { return s === buffersComponent.preHybridizationScale.slides; });
    if (preHybridizationScale !== undefined) {
        bufferState = __assign(__assign({}, bufferState), { preHybridizationScale: preHybridizationScale });
    }
    else {
        bufferState = __assign(__assign({}, bufferState), { preHybridizationScale: defaultScale });
    }
    if (buffersComponent instanceof RnaCishLeicaBuffersComponent || buffersComponent instanceof RnaCishOncoreProXBuffersComponent || buffersComponent instanceof RnaCishManualBuffersComponent) {
        var bluingAgentScale = catalogScales
            .find(function (s) { return s === buffersComponent.bluingAgentScale.slides; });
        if (bluingAgentScale !== undefined) {
            bufferState = __assign(__assign({}, bufferState), { bluingAgentScale: bluingAgentScale });
        }
        else {
            bufferState = __assign(__assign({}, bufferState), { bluingAgentScale: defaultScale });
        }
        var hrpQuencherScale = catalogScales
            .find(function (s) { return s === buffersComponent.hrpQuencherScale.slides; });
        if (hrpQuencherScale !== undefined) {
            bufferState = __assign(__assign({}, bufferState), { hrpQuencherScale: hrpQuencherScale });
        }
        else {
            bufferState = __assign(__assign({}, bufferState), { hrpQuencherScale: defaultScale });
        }
    }
    else {
        var antigenRetrievalScale = catalogScales
            .find(function (s) { return s === buffersComponent.antigenRetrievalScale.slides; });
        if (antigenRetrievalScale !== undefined) {
            bufferState = __assign(__assign({}, bufferState), { antigenRetrievalScale: antigenRetrievalScale });
        }
        else {
            bufferState = __assign(__assign({}, bufferState), { antigenRetrievalScale: defaultScale });
        }
        var dewaxScale = catalogScales
            .find(function (s) { return s === buffersComponent.dewaxScale.slides; });
        if (dewaxScale !== undefined) {
            bufferState = __assign(__assign({}, bufferState), { dewaxScale: dewaxScale });
        }
        else {
            bufferState = __assign(__assign({}, bufferState), { dewaxScale: defaultScale });
        }
    }
    if (kitPrice instanceof RnaCishKitPrice) {
        if (kitPrice.buffersPriceCustom) {
            bufferState = __assign(__assign({}, bufferState), { customPrice: {
                    listPriceCents: 0,
                    effectivePriceCents: kitPrice.buffersPriceCents,
                } });
        }
    }
    else if (kitPrice instanceof BundleOfKitsPrice) {
        var individualKitPrice = kitPrice.individualKitPrices.find(function (k) { return k.channel === 1; });
        if (individualKitPrice) {
            var buffersPrice = individualKitPrice.buffersPrices.find(function (b) { return b.index === 2; });
            if (buffersPrice === null || buffersPrice === void 0 ? void 0 : buffersPrice.priceCustom) {
                bufferState = __assign(__assign({}, bufferState), { customPrice: {
                        listPriceCents: 0,
                        effectivePriceCents: buffersPrice.priceCents,
                    } });
            }
        }
    }
    return bufferState;
};
var findRnaCishMatchingAmplifierOrDefault = function (amp, catalog) {
    var found = catalog.hcrAmplifiers.find(function (a) { return a.id === amp.id; });
    if (found !== undefined) {
        return found;
    }
    return catalog.defaultHcrAmplifier;
};
var extractStringFromParentheses = function (input) {
    var match = input.match(/\(([^)]+)\)/);
    return match ? match[1] : null;
};
//# sourceMappingURL=RnaCishKitToAdminFormState.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/rna-cish/RnaCishKitToAdminFormState.js
// module id = 182
// module chunks = 0